module.exports = __webpack_public_path__ + "img/metric-qr-code.ec86f440.png";